<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <!--DETAIL COLLABORATOR-->
    <div class="row" *ngIf="currentUser">
      <section class="col-12" id="page-accordion">
        <div class="card" *ngIf="currentUser">
          <div class="card-title pt-2 px-2 mb-0">
            <h4 class="mb-0">{{ "DETAIL_COLLABORATOR" | translate }}</h4>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-12" *ngIf="currentUser.firstname">
                <label class="font-small-4 font-weight-bold">{{ "FIRSTNAME" | translate }}:</label>
                <p class="font-medium-1">{{ currentUser.firstname }}</p>
              </div>
              <div class="col-md-4 col-12" *ngIf="currentUser.lastname">
                <label class="font-small-4 font-weight-bold">{{ "LASTNAME" | translate }}:</label>
                <p class="font-medium-1">{{ currentUser.lastname }}</p>
              </div>
              <div class="col-md-4 col-12" *ngIf="currentUser.business_name">
                <label class="font-small-4 font-weight-bold">{{ "BUSINESS_NAME" | translate }}:</label>
                <p class="font-medium-1">{{ currentUser.business_name }}</p>
              </div>
              <div class="col-md-4 col-12">
                <label class="font-small-4 font-weight-bold">{{ "TYPE" | translate }}:</label>
                <p class="font-medium-1">{{ (currentUser.type_code === "stage" ? "INTERN" : "VAT_NUMBER") | translate }}</p>
              </div>
              <div class="col-md-4 col-12">
                <label class="font-small-4 font-weight-bold">{{ "DAILY_COST_PRESUMED" | translate }}:</label>
                <p class="font-medium-1">{{ _utilService.addDotsToNumber(currentUser.contract.total_daily || 0) }} €</p>
              </div>
              <div class="col-md-4 col-12" *ngIf="currentUser.birthday">
                <label class="font-small-4 font-weight-bold">{{ "APPRENTICEABLE" | translate }}:</label>
                <p class="font-medium-1 text-{{ currentUser.apprenticeship >= 30 ? 'danger' : 'success' }}">{{ currentUser.apprenticeship >= 30 ? ("NO" | translate) : ("YES" | translate) }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- PROPOSE_CONTRACT_SECTION-->
    <div class="row">
      <section class="col-12">
        <div class="card" *ngIf="currentUser">
          <div class="card-body">
            <div class="card-title">
              <h4>{{ "PROPOSAL" | translate }}</h4>
            </div>
            <!-- TYPE CONTRACT INFOMRATION-->
            <div class="row">
              <div [class]="'form-group col-12 col-md-' + (_contractManager.typeIsApprendistato || _contractManager.typeIsStage ? 4 : 6)">
                <label for="contract_id">{{ "CONTRACT_TYPE" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  id="contract_id"
                  [items]="contractList"
                  bindLabel="name"
                  bindValue="id"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [(ngModel)]="_contractManager.data.contract"
                  class="{{ !_contractManager.data.contract ? 'is-invalid' : '' }}"
                  (change)="_contractManager.changeContract($event)"
                ></ng-select>
              </div>
              <div class="form-group col-12 col-md-4" *ngIf="_contractManager.typeIsApprendistato">
                <label for="contract_level">{{ "DURATION" | translate }}<sup class="text-danger">*</sup></label>
                <input
                  type="number"
                  min="1"
                  max="3"
                  [defaultValue]="3"
                  class="form-control {{ !_contractManager.contractDuration ? 'is-invalid' : '' }}"
                  [(ngModel)]="_contractManager.contractDuration"
                  [ngModelOptions]="{ standalone: true }"
                  (change)="_contractManager.updateData()"
                />
              </div>
              <div [class]="'form-group col-12 col-md-' + (_contractManager.typeIsApprendistato ? 4 : 6)" *ngIf="!_contractManager.typeIsStage">
                <label for="contract_level">{{ "LEVEL" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  *ngIf="_contractManager.levels_for_select.length > 0"
                  id="contract_level"
                  class="{{ !_contractManager.data.level ? 'is-invalid' : '' }}"
                  [(ngModel)]="_contractManager.data.level"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  (change)="_contractManager.changeLevel(true, false)"
                >
                  <ng-option *ngFor="let lvl of _contractManager.levels_for_select" [value]="lvl">{{ lvl }}</ng-option>
                </ng-select>
                <select *ngIf="_contractManager.levels_for_select.length < 1" disabled class="form-control"></select>
              </div>
              <div class="form-group col-12 col-md-4" *ngIf="_contractManager.typeIsApprendistato || _contractManager.typeIsStage">
                <label for="contract_level">{{ "TUTOR" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select [closeOnSelect]="true" [clearable]="false" [(ngModel)]="_contractManager.data.tutor_hash" class="{{ !_contractManager.data.tutor_hash ? 'is-invalid' : '' }}">
                  <ng-option *ngFor="let tutor of _contractManager.tutors" class="form-control {{ !_contractManager.data.tutor_hash ? 'is-invalid' : '' }}" [value]="tutor.hash"
                    >{{ tutor.firstname }} {{ tutor.lastname }}</ng-option
                  >
                </ng-select>
              </div>
              <div class="form-group col-md-4 col-12" *ngIf="!_contractManager.typeIsStage">
                <label for="contract_trial">{{ "CONTRACT_TRIAL_DAYS" | translate }}<sup class="text-danger">*</sup></label>
                <input readonly type="number" id="contract_trial" class="form-control" [(ngModel)]="_contractManager.data.trial" />
              </div>
              <div class="form-group col-md-4 col-12">
                <label for="contract_role">{{ "DUTY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  bindValue="id"
                  bindLabel="name"
                  id="contract_role"
                  [(ngModel)]="_contractManager.data.role"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="_userFigureService.list"
                  class="{{ !_contractManager.data.role ? 'is-invalid' : '' }}"
                ></ng-select>
              </div>
              <div class="form-group col-md-4 col-12">
                <label for="contract_program">{{ "CONTRACT_PROGRAM" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  id="contract_program"
                  [items]="_contractService.programs"
                  bindLabel="label"
                  bindValue="value"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [(ngModel)]="_contractManager.data.program"
                  class="{{ !_contractManager.data.program ? 'is-invalid' : '' }}"
                >
                </ng-select>
              </div>
              <div [class]="'form-group col-12 col-md-' + (_contractManager.typeIsApprendistato || _contractManager.typeIsStage ? 4 : 6)">
                <label for="contract_start_date">{{ "START_DATE" | translate }}<sup class="text-danger">*</sup></label>
                <input
                  type="date"
                  id="contract_start_date"
                  [min]="today_date"
                  [(ngModel)]="_contractManager.data.start_date"
                  (change)="_contractManager.updateData()"
                  class="form-control {{ !_contractManager.data.start_date ? 'is-invalid' : '' }}"
                />
              </div>
              <div [class]="'form-group col-12 col-md-' + (_contractManager.typeIsApprendistato || _contractManager.typeIsStage ? 4 : 6)">
                <label for="contract_end_date">{{ "END_DATE" | translate }}<sup class="text-danger" *ngIf="this._contractManager.data.contract !== 1">*</sup></label>
                <input
                  type="date"
                  id="contract_end_date"
                  [min]="today_date"
                  [readOnly]="_contractManager.typeIsIndeterminate || _contractManager.typeIsApprendistato"
                  (change)="_contractManager.updateData()"
                  class="form-control {{ !_contractManager.data.end_date && !_contractManager.typeIsIndeterminate ? 'is-invalid' : '' }}"
                  [(ngModel)]="_contractManager.data.end_date"
                />
              </div>
            </div>
            <!-- /TYPE CONTRACT INFOMRATION-->

            <!-- COST CONTRACT INFOMRATION-->
            <div class="row">
              <div class="form-group col-12">
                <h4 class="mb-0 mt-2">{{ "EMPLOYEE_COSTS" | translate }}</h4>
              </div>
              <div class="form-group col-12" *ngIf="_contractManager.current_lvl && _contractManager.next_lvl && !_contractManager.typeIsStage">
                <p class="mb-0 font-small-4">
                  {{ "MINIMUM_RAL_FOR_LEVEL" | translate }}
                  <strong>{{ _utilService.addDotsToNumber(_contractManager.current_lvl.salary_yearly_gross) }}&euro;</strong>
                  <span *ngIf="_contractManager.data.level != 'B3'">
                    | {{ "MAXIMUM_RAL_FOR_LEVEL" | translate }} <strong>{{ _utilService.addDotsToNumber(_contractManager.next_lvl.salary_yearly_gross) }}&euro;</strong></span
                  >
                </p>
              </div>
              <div class="form-group col-md-6 col-12" *ngIf="!_contractManager.typeIsStage">
                <label for="salary_yearly_gross">{{ "SALARY_YEARLY_GROSS" | translate }}<sup class="text-danger">*</sup></label>
                <div class="input-group input-group-merge {{ !_contractManager.data.salary_yearly_gross ? 'is-invalid' : '' }}">
                  <div class="input-group-prepend">
                    <span class="input-group-text">&euro;</span>
                  </div>
                  <input
                    [readOnly]="!_contractManager.current_lvl || !_contractManager.next_lvl"
                    type="text"
                    id="salary_yearly_gross"
                    [(ngModel)]="_contractManager.data.salary_yearly_gross"
                    class="form-control bg-white {{ !_contractManager.data.salary_yearly_gross ? 'is-invalid' : '' }}"
                    (change)="transformRal($event.target.value)"
                  />
                </div>
              </div>
              <div class="form-group col-md-3 col-12" *ngIf="!_contractManager.typeIsStage">
                <label for="bonus">{{ "MONTHLY_BONUSES" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text">&euro;</span>
                  </div>
                  <input
                    type="text"
                    [readOnly]="!_contractManager.current_lvl || !_contractManager.next_lvl"
                    id="bonus"
                    (change)="_contractManager.updateData('daily_bonus')"
                    class="form-control bg-white"
                    [(ngModel)]="_contractManager.data.bonus"
                  />
                </div>
              </div>
              <div class="form-group col-md-3 col-12" *ngIf="!_contractManager.typeIsStage">
                <label for="production_bonus">{{ "PRODUCTION_BONUS" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text">&euro;</span>
                  </div>
                  <input
                    type="text"
                    [readOnly]="!_contractManager.current_lvl || !_contractManager.next_lvl"
                    id="production_bonus"
                    (change)="_contractManager.updateData('production_bonus')"
                    class="form-control bg-white"
                    [(ngModel)]="_contractManager.data.production_bonus"
                  />
                </div>
              </div>
              <div class="col-12"></div>
              <div class="form-group col-md-4 col-12">
                <label for="net_monthly_12">{{ _contractManager.typeIsStage ? ("SALARY_MONTH" | translate) : ("SALARY_MONTH_12" | translate) }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text {{ !_contractManager.typeIsStage ? 'bg-readonly' : '' }}">&euro;</span>
                  </div>
                  <input [readOnly]="!_contractManager.typeIsStage" type="text" id="net_monthly_12" class="form-control" [(ngModel)]="_contractManager.data.net_monthly_12" (change)="_contractManager.updateData()" />
                </div>
              </div>
              <div class="form-group col-md-4 col-12" *ngIf="!_contractManager.typeIsStage">
                <label for="net_monthly_13">{{ "SALARY_MONTH_13" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-readonly">&euro;</span>
                  </div>
                  <input readonly="readonly" type="text" id="net_monthly_13" class="form-control" [value]="_contractManager.data.net_monthly_13" />
                </div>
              </div>
              <div class="form-group col-md-4 col-12" *ngIf="!_contractManager.typeIsStage">
                <label for="total_monthly_13">{{ "TOTAL_SALARY_MONTH_13" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-readonly">&euro;</span>
                  </div>
                  <input readonly="readonly" type="text" id="total_monthly_13" class="form-control" [value]="_contractManager.data.total_net_monthly_13" />
                </div>
              </div>
            </div>
            <!-- /COST CONTRACT INFOMRATION-->

            <!-- BONUS TICKET CONTRACT INFOMRATION-->
            <div class="row" *ngIf="!_contractManager.typeIsStage">
              <div class="form-group col-12">
                <h4 class="mb-0 mt-2">{{ "BONUS_TICKET" | translate }}</h4>
              </div>
              <div class="form-group col-md-3 col-12">
                <label for="ticket_type">{{ "TICKET_TYPE" | translate }}</label>
                <select
                  name="ticket_type"
                  id="ticket_type"
                  class="form-control"
                  [(ngModel)]="_contractManager.data.ticket_type"
                  (change)="_contractManager.data.ticket_month_number = _contractManager.data.ticket_type === 'variabile' ? 20 : 0; _contractManager.updateData()"
                >
                  <option disabled>{{ "TICKET_TYPE" | translate }}</option>
                  <option value="fisso">{{ "STATIC" | translate }}</option>
                  <option value="variabile">{{ "VARIABLE" | translate }}</option>
                </select>
              </div>
              <div class="form-group col-md-3 col-12">
                <label for="ticket_month_number">{{ "TICKET_MONTH_NUMBER" | translate }}</label>
                <input
                  type="number"
                  (change)="_contractManager.updateData()"
                  [readOnly]="_contractManager.data.ticket_type === 'variabile'"
                  id="ticket_month_number"
                  class="form-control"
                  [(ngModel)]="_contractManager.data.ticket_month_number"
                />
              </div>
              <div class="form-group col-md-3 col-12">
                <label for="ticket_value">{{ "TICKET_DAILY_VALUE" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text">&euro;</span>
                  </div>
                  <input type="text" id="ticket_value" (change)="transformTicketValue($any($event.target))" class="form-control" [(ngModel)]="_contractManager.data.ticket_value" />
                </div>
              </div>
              <div class="form-group col-md-3 col-12">
                <label for="total_monthly_13">{{ "TICKET_TOTAL_MONTH" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-readonly">&euro;</span>
                  </div>
                  <input readonly="readonly" type="text" class="form-control" [value]="calculateTicketTotalMonth()" />
                </div>
              </div>
            </div>
            <!-- /BONUS TICKET CONTRACT INFOMRATION-->

            <!-- FOOTER PROPOSE CONTRACT SECTION-->
            <div class="row border-top pt-2 mt-1 align-items-center">
              <div class="col-md-6 col-12 contract-daily-cost">
                {{ "TOTAL_SALARY_DAILY" | translate }}
                <strong>{{ _contractManager.data.total_daily }} &euro;</strong>
              </div>
              <div class="col-md-6 col-12 text-right" *ngIf="_authenticationService.hasCapability('create_transformation')">
                <button class="btn btn-primary" (click)="submit()" [disabled]="isDisabledSave()">{{ "SAVE" | translate }}</button>
              </div>
            </div>
            <!-- /FOOTER PROPOSE CONTRACT SECTION-->
          </div>
        </div>
        <!-- /PROPOSE_CONTRACT_SECTION-->
      </section>
    </div>
  </div>
</div>
